import React from 'react'
import '../../styles/Utils/Popover.css'
import { OverlayTrigger, Popover as PopoverBootstrap } from 'react-bootstrap'

function Popover({ title, body, trigger }) {

    return (

        <OverlayTrigger
            trigger={['hover']}
            placement="top"
            overlay={
                <PopoverBootstrap id="popover-trigger-hover">
                    <PopoverBootstrap.Header>{title}</PopoverBootstrap.Header>
                    <PopoverBootstrap.Body>
                        {body}
                    </PopoverBootstrap.Body>
                </PopoverBootstrap>
            }>
            {trigger}
        </OverlayTrigger>

    )

}

export default Popover